module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "contents"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('strong', [_vm._v("CONTENTS")])])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('strong')]), _c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/foreword#foreword"
    }
  }, [_vm._v("FOREWORD")]), _vm._v(" Joi Ito, Director, MIT Media Lab")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/preface#preface"
    }
  }, [_vm._v("PREFACE")]), _vm._v(" Notes from a Practicing Heart")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/intro#intro"
    }
  }, [_vm._v("INTRODUCTION")]), _vm._v(" What Are Social Laboratories?")])]), _vm._v(" "), _c('p', {
    staticClass: "tocn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/intro#introlev1"
    }
  }, [_c('em', [_vm._v("What Does It Mean to Be Winning")]), _vm._v("?")]), _c('em', [_c('a', {
    attrs: {
      "href": "#/xhtml/intro#introlev2"
    }
  }, [_vm._v("Playing in the World Cup")])]), _c('br'), _c('a', {
    attrs: {
      "href": "#/xhtml/intro#introlev3"
    }
  }, [_c('em', [_vm._v("The Scale-Free Laboratory")])]), _c('br'), _c('em', [_c('a', {
    attrs: {
      "href": "#/xhtml/intro#introlev4"
    }
  }, [_vm._v("A Cascade of Social Labs")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch01#ch01",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("1 The Perfect Storm of Complexity")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocn"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch01#ch01lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Perfect Challenge")])]), _c('br'), _c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch01#ch01lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Is a Complex Social Challenge?")])]), _c('br'), _c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch01#ch01lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Futile Optimism of Optimization")])]), _c('br'), _c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch01#ch01lev4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Yemen as a Natural Experiment")])]), _c('br'), _c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch01#ch01lev5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Too Big to Fail, Too Big to Jail")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("2 The Strategic Vacuum")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocn"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch02#ch02lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Business as Usual")])]), _c('br'), _c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch02#ch02lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Expert-Planning Paradigm")])]), _c('br'), _c('span', {
    attrs: {
      "href": "#/xhtml/ch02#ch02lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Flying Autopilot in the Perfect Storm")])]), _c('br'), _c('span', {
    attrs: {
      "href": "#/xhtml/ch02#ch02lev4",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("A Lack of Genuine Strategic Intent")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("3 The Sustainable Food Lab: From Farm to Fork")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocn"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03#ch03lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Race to the Bottom")])]), _c('br'), _c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03#ch03lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Multiple and Conflicting Logics of Food")])]), _c('br'), _c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03#ch03lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Is Sustainable?")])]), _c('br'), _c('span', {
    attrs: {
      "href": "#/xhtml/ch03#ch03lev4",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Systemic Spread Betting")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("4 The Bhavishya Lab: The Silent Emergency")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocn"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch04lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Bhavishya Alliance")])]), _c('br'), _c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch04lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Moon Shot")])]), _c('br'), _c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch04lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Movement Requires Friction")])]), _c('br'), _c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch04lev4",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Fail Early, Fail Often")])]), _c('br'), _c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch04lev5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Business as Usual and Its Radical Refusals")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("5 The New Ecologies of capital")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocn"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05#ch05lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The End of the Beginning")])]), _c('br'), _c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05#ch05lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Emerging Forms of Capital and Preventing Collapse")])]), _c('br'), _c('span', {
    attrs: {
      "href": "#/xhtml/ch05#ch05lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Dumbest Idea in the World")])]), _c('br'), _c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05#ch05lev4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Rainforests, Fewer Plantations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("6 The Rise of the Agilistas")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocn"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06#ch06lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Practical Wisdom of Social Labs")])]), _c('br'), _c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06#ch06lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Starting with Current Realities")])]), _c('br'), _c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06#ch06lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Events Rupture Dispositions")])]), _c('br'), _c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06#ch06lev4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Right Stuff")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("7 Steps Toward a Theory of Systemic Action")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocn"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07#ch07lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("First Requirement: Constitute a Diverse Team")])]), _c('br'), _c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07#ch07lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Second Requirement: Design an Iterative Process")])]), _c('br'), _c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07#ch07lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Third Requirement: Actively Create Systemic Spaces")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("8 Starting a Social Lab: Seven How-Tos")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocn"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch08#ch08lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Strategic versus Tactical Thinking")])]), _c('br'), _c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch08#ch08lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("#1 Clarify Intention")])]), _c('br'), _c('span', {
    attrs: {
      "href": "#/xhtml/ch08#ch08lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("#2 Broadcast an Invitation")])]), _c('br'), _c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch08#ch08lev4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("#3 Work Your Networks")])]), _c('br'), _c('span', {
    attrs: {
      "href": "#/xhtml/ch08#ch08lev5",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("#4 Recruit Willing People")])]), _c('br'), _c('span', {
    attrs: {
      "href": "#/xhtml/ch08#ch08lev6",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("#5 Set Direction")])]), _c('br'), _c('span', {
    attrs: {
      "href": "#/xhtml/ch08#ch08lev7",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("#6 Design in Stacks")])]), _c('br'), _c('span', {
    attrs: {
      "href": "#/xhtml/ch08#ch08lev8",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("#7 Find Cadence")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/conclusion#conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("CONCLUSION Next-Generation Social Labs")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocn"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/conclusion#conclusionlev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Averting the Zombie Apocalypse")])]), _c('br'), _c('span', {
    attrs: {
      "href": "#/xhtml/conclusion#conclusionlev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("State Collapse: A Stabilization Strategy")])]), _c('br'), _c('span', {
    attrs: {
      "href": "#/xhtml/conclusion#conclusionlev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Climate Change: A Mitigation Strategy")])]), _c('br'), _c('span', {
    attrs: {
      "href": "#/xhtml/conclusion#conclusionlev4",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Community Resilience: An Adaptation Strategy")])]), _c('br'), _c('span', {
    attrs: {
      "href": "#/xhtml/conclusion#conclusionlev5",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Battle of the Parts versus the Whole")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ack#ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("ACKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("NOTES")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bib#bib",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("BIBLIOGRAPHY")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index#index",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("INDEX")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/author#author",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("ABOUT THE AUTHOR")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/reos#reos",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("ABOUT REOS")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef6128c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 75
// module chunks = 0